import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default function withBreakpoint(Component) {
  return function WrappedComponent(props) {
    const myHookValue = useBreakpoint(true);
    return <Component {...props} breakpoint={myHookValue} />;
  }
}